import React from 'react';

const STATS = [
  { value: '50K+', label: 'Verified Jobs'    },
  { value: '12K+', label: 'Recruiters'       },
  { value: '2+', label: 'Partner Colleges' },
  { value: '10+',  label: 'Indian Languages' },
];

export default function TrustStrip() {
  return (
    <div className="border-y border-gray-100 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-6 md:py-8 grid grid-cols-2 md:grid-cols-4 gap-px bg-gray-100">
        {STATS.map(({ value, label }) => (
          <div key={label} className="bg-white flex flex-col items-center py-5 px-3 md:py-6 md:px-4">
            <span className="font-display font-black text-2xl md:text-4xl text-ink-900 tabular-nums">
              {value}
            </span>
            <span className="text-xs md:text-sm font-medium text-ink-500 mt-1 text-center">{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
